import styled from 'styled-components';

export const SelectWrapper = styled.label`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;

  div[class*='-control'] {
    border: none;
    background-color: ${(props) => props.theme.colors.transparent} !important;
  }

  div[class*='singleValue'] {
    color: ${(props) => props.theme.colors.link} !important;
    text-align: end;
  }

  div[class*='menu'] {
    min-width: 200px;
    right: 0;
  }

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
    flex-direction: column;
    align-items: start;

    div[class*='-control'] {
      border: 1px solid ${(props) => props.theme.colors.link};
    }
    div[class*='singleValue'] {
      text-align: start;
    }
  }

  &.light {
    flex-direction: row;
    align-items: center;

    div[class*='-control'] {
      border: none;
    }
  }
`;
